import React, { useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import Piano from '../utils/Piano';
import lang from '../lang.json';

const Module6c = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module6c;

    const [pause, setPause] = useState(true);
    const [boxSelected1, setBoxSelected1] = useState([false, false]);
    const [boxSelected2, setBoxSelected2] = useState([false, false]);
    const [boxSelected3, setBoxSelected3] = useState([false, false]);

    const animCallback1 = (time, paused) => {
        setPause(paused);
        if (time >= 26.14 && time < 28.51) {
            let boxSelected1Copy = [...boxSelected1];
            boxSelected1Copy[0] = true;
            setBoxSelected1(boxSelected1Copy);
        }
        else {
            let boxSelected1Copy = [...boxSelected1];
            boxSelected1Copy[0] = false;
            setBoxSelected1(boxSelected1Copy);
        }
        if (time >= 27.61 && time < 31.52) {
            let boxSelected2Copy = [...boxSelected2];
            boxSelected2Copy[0] = true;
            setBoxSelected2(boxSelected2Copy);
        }
        else {
            let boxSelected2Copy = [...boxSelected2];
            boxSelected2Copy[0] = false;
            setBoxSelected2(boxSelected2Copy);
        }
        if (time >= 35.95 && time < 39.33) {
            let boxSelected3Copy = [...boxSelected3];
            boxSelected3Copy[0] = true;
            setBoxSelected3(boxSelected3Copy);
        }
        else {
            let boxSelected3Copy = [...boxSelected3];
            boxSelected3Copy[0] = false;
            setBoxSelected3(boxSelected3Copy);
        }
    }

    const animCallback2 = (time, paused) => {
        setPause(paused);
        console.log(time);
        if (time >= 15.4 && time < 19.9) {
            let boxSelected1Copy = [...boxSelected1];
            boxSelected1Copy[1] = true;
            setBoxSelected1(boxSelected1Copy);
        }
        else {
            let boxSelected1Copy = [...boxSelected1];
            boxSelected1Copy[1] = false;
            setBoxSelected1(boxSelected1Copy);
        }
        if (time >= 25.97 && time < 27.81) {
            let boxSelected2Copy = [...boxSelected2];
            boxSelected2Copy[1] = true;
            setBoxSelected2(boxSelected2Copy);
        }
        else {
            let boxSelected2Copy = [...boxSelected2];
            boxSelected2Copy[1] = false;
            setBoxSelected2(boxSelected2Copy);
        }
        if (time >= 27.45 && time < 30.91) {
            let boxSelected3Copy = [...boxSelected3];
            boxSelected3Copy[1] = true;
            setBoxSelected3(boxSelected3Copy);
        }
        else {
            let boxSelected3Copy = [...boxSelected3];
            boxSelected3Copy[1] = false;
            setBoxSelected3(boxSelected3Copy);
        }
    }

    return (
        <>
            <img
                src={process.env.PUBLIC_URL + "/assets/images/module6c/1.jpg"}
                style={{ position: 'absolute', top: '0px', left: '0px', width: "660px", zIndex: 2 }}
            />
            <Piano
                dirName={"piano6c1"}
                numberOfPages={1}
                pageSpeeds={[74.1]} // duree page
                musicName={"piano6c1"}
                callback={animCallback1}
                style={{ position: 'absolute', top: '30px' }}
            />
            <Piano
                dirName={"piano6c2"}
                numberOfPages={1}
                pageSpeeds={[33]} // duree page
                musicName={"piano6c2"}
                callback={animCallback2}
                height={115}
                width={330}
                style={{ position: 'absolute', top: '330px', left: '310px' }}
            />
            {/*transparent box*/}
            <div
                id='box1'
                style={{
                    position: 'absolute',
                    top: '67px',
                    left: '244px',
                    width: "18px",
                    height: "70px",
                    border: "1px solid black",
                    zIndex: 11,
                    backgroundColor: boxSelected1[0]||boxSelected1[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                id='box2'
                style={{
                    position: 'absolute',
                    top: '74px',
                    left: '256px',
                    width: "32px",
                    height: "70px",
                    border: "1px solid black",
                    zIndex: 11,
                    backgroundColor: boxSelected2[0]||boxSelected2[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                id='box3'
                style={{
                    position: 'absolute',
                    top: '109px',
                    left: '327px',
                    width: "27px",
                    height: "59px",
                    border: "1px solid black",
                    zIndex: 11,
                    backgroundColor: boxSelected3[0]||boxSelected3[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                id='box4'
                style={{
                    position: 'absolute',
                    top: '379px',
                    left: '474px',
                    width: "42px",
                    height: "36px",
                    border: "1px solid black",
                    zIndex: 11,
                    backgroundColor: boxSelected1[0]||boxSelected1[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                id='box5'
                style={{
                    position: 'absolute',
                    top: '370px',
                    left: '579px',
                    width: "18px",
                    height: "28px",
                    border: "1px solid black",
                    zIndex: 11,
                    backgroundColor: boxSelected2[0]||boxSelected2[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />
            <div
                id='box6'
                style={{
                    position: 'absolute',
                    top: '406px',
                    left: '595px',
                    width: "32px",
                    height: "34px",
                    border: "1px solid black",
                    zIndex: 11,
                    backgroundColor: boxSelected3[0]||boxSelected3[1] ? "rgba(252, 166, 53, 0.6)" : "rgba(235, 194, 99, 0.3)"
                }}
            />

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 10,
                    margin: 0,
                    top: 4,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                className="t1 text"
                style={{
                    position: 'absolute',
                    top: '310px',
                    left: '10px', //PB30
                    width: '280px',
                    opacity: 1,
                    zIndex: 3,
                    color: 'white',
                    fontSize: '15px',
                    padding: '5px', 
                }}
            >
                {texts.lang30} 
            </p>
            <p
                style={{
                    position: 'absolute',
                    right: 10,
                    margin: 0,
                    top: 306,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang32}</p>
            <p
                style={{
                    position: 'absolute',
                    right: 10,
                    margin: 0,
                    top: 7,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang31}</p>
        </>
    );
}

export default Module6c;
